import {
    exportTimekeeping,
    exportTimekeepingSelectRow
} from "../../../../../../api/hrm/timekeeping/time-sheet/timesheet";
import {t} from "i18next";
import dayjs from "dayjs";
export const getFormattedDate = () => {
    return dayjs().format("_YYMMDD_HHmmss");
};

export function normalizeString(str) {
    if(str === null || str === undefined) return ""
    const vietnameseMap = {
        'à': 'a', 'á': 'a', 'ạ': 'a', 'ả': 'a', 'ã': 'a', 'â': 'a', 'ầ': 'a', 'ấ': 'a', 'ậ': 'a', 'ẩ': 'a', 'ẫ': 'a', 'ă': 'a', 'ằ': 'a', 'ắ': 'a', 'ặ': 'a', 'ẳ': 'a', 'ẵ': 'a',
        'è': 'e', 'é': 'e', 'ẹ': 'e', 'ẻ': 'e', 'ẽ': 'e', 'ê': 'e', 'ề': 'e', 'ế': 'e', 'ệ': 'e', 'ể': 'e', 'ễ': 'e',
        'ì': 'i', 'í': 'i', 'ị': 'i', 'ỉ': 'i', 'ĩ': 'i',
        'ò': 'o', 'ó': 'o', 'ọ': 'o', 'ỏ': 'o', 'õ': 'o', 'ô': 'o', 'ồ': 'o', 'ố': 'o', 'ộ': 'o', 'ổ': 'o', 'ỗ': 'o', 'ơ': 'o', 'ờ': 'o', 'ớ': 'o', 'ợ': 'o', 'ở': 'o', 'ỡ': 'o',
        'ù': 'u', 'ú': 'u', 'ụ': 'u', 'ủ': 'u', 'ũ': 'u', 'ư': 'u', 'ừ': 'u', 'ứ': 'u', 'ự': 'u', 'ử': 'u', 'ữ': 'u',
        'ỳ': 'y', 'ý': 'y', 'ỵ': 'y', 'ỷ': 'y', 'ỹ': 'y',
        'đ': 'd', 'Đ': 'D'
    };

    return str
        .split("")
        .map(char => vietnameseMap[char] || char)
        .join("")
        .replace(/\s+/g, "_")
        .replace(/[^a-zA-Z0-9_]/g, "")
        .toLowerCase();
}

export function exportWorkHour(value, month , year) {
    const param = {
        month: month,
        year: year,
        typeExport :value
    }

    exportTimekeeping(param).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${t("tnp.components.timesheetViewport.text77")}${getFormattedDate()}.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();
    })
}

export function exportLeave(value, month, year) {
    const param = {
        month: month,
        year: year,
        typeExport :value
    }

    exportTimekeeping(param).then((res) => {

        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${t("tnp.components.timesheetViewport.text78")}${getFormattedDate()}.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();
    })
}

export function exportTimekeepingFollowApp(value,month, year) {
    const param = {
        month: month,
        year: year,
        typeExport :value
    }

    exportTimekeeping(param).then((res) => {

        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${t("tnp.components.timesheetViewport.text79")}${getFormattedDate()}.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();
    })
}

export function exportTimekeepingWork(value, month , year) {
    const param = {
        month: month,
        year: year,
        typeExport :value
    }
    exportTimekeeping(param).then((res) => {

        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${t("tnp.components.timesheetViewport.text80")}${getFormattedDate()}.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();
    })
}

export function exportCheckInout(value, month , year){
    const param = {
        month: month,
        year: year,
        typeExport :value
    }

    exportTimekeeping(param).then((res) => {

        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${t("tnp.components.timesheetViewport.text81")}${getFormattedDate()}.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();
    })
}


export function exportWorkHourSymbol(value, month , year){
    const param = {
        month: month,
        year: year,
        typeExport :value
    }

    exportTimekeeping(param).then((res) => {

        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${t("tnp.components.timesheetViewport.text82")}${getFormattedDate()}.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();
    })
}
export function exportShiftWork(value, month , year){
    const param = {
        month: month,
        year: year,
        typeExport :value
    }

    exportTimekeeping(param).then((res) => {

        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${t("tnp.components.timesheetViewport.text83")}${getFormattedDate()}.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();
    })
}
export function exportShiftWorkHour(value, month , year){
    const param = {
        month: month,
        year: year,
        typeExport :value
    }

    exportTimekeeping(param).then((res) => {

        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${t("tnp.components.timesheetViewport.text84")}${getFormattedDate()}.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();
    })
}
export function exportShiftOvertime(value, month , year){
    const param = {
        month: month,
        year: year,
        typeExport :value
    }

    exportTimekeeping(param).then((res) => {

        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${t("tnp.components.timesheetViewport.text85")}${getFormattedDate()}.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();
    })
}

export function exportShiftOvertimeHour(value, month , year){
    const param = {
        month: month,
        year: year,
        typeExport :value
    }

    exportTimekeeping(param).then((res) => {

        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${t("tnp.components.timesheetViewport.text86")}${getFormattedDate()}.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();
    })
}

export function exportShiftOvertimeShift(value, month , year){
    const param = {
        month: month,
        year: year,
        typeExport :value
    }

    exportTimekeeping(param).then((res) => {

        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${t("tnp.components.timesheetViewport.text87")}${getFormattedDate()}.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();
    })
}

export function exportWorkSymbolAll(value, month , year){
    const param = {
        month: month,
        year: year,
        typeExport :value
    }

    exportTimekeeping(param).then((res) => {

        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${t("tnp.components.timesheetViewport.text88")}${getFormattedDate()}.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();
    })
}

export function exportWorkSymbolKey(value, month , year){
    const param = {
        month: month,
        year: year
    }
    const key = value ;

    exportTimekeepingSelectRow(param, key).then((res) => {

        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${t("tnp.components.timesheetViewport.text88")}${getFormattedDate()}.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();
    })
}
